import React from 'react';
import styled from 'styled-components';
import { getPageMessage } from '../../../shared/constants/pageMessages';

const ExhibitionVenueViewerMobile: React.FC = () => {
  return (
    <ViewerShell onClick={(e) => e.stopPropagation()}>
      <ScrollBody>
        <ComingSoon>{getPageMessage('EXHIBITION_DETAIL_COMING_SOON')}</ComingSoon>
      </ScrollBody>
    </ViewerShell>
  );
};

const ViewerShell = styled.section`
  flex: 1;
  min-width: 0;
  min-height: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const ScrollBody = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  align-items: flex-start;
`;

const ComingSoon = styled.div`
  ${({ theme }) => theme.typography.Body_04};
  color: ${({ theme }) => theme.colors.color_Gray_04};
`;

export default ExhibitionVenueViewerMobile;
